import React from 'react'
import { useForm, Controller } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import moment from 'moment-timezone'
import Select from 'react-select'
import { countries } from '../../../lib/constants'
import { airportSchema } from './schema'

function AirportModal({ isOpen, onClose, airportData, mode, onSubmit }) {
    const {
        register,
        handleSubmit,
        reset,
        control,
        formState: { errors }
    } = useForm({
        defaultValues: airportData || {},
        resolver: yupResolver(airportSchema)
    })

    // Format options for react-select
    const countryOptions = countries.map(country => ({
        value: country.value,
        label: country.label
    }))

    const timezoneOptions = moment.tz.names().map(tz => ({
        value: tz,
        label: `${tz} (${moment.tz(tz).format('Z')})`
    }))

    React.useEffect(() => {
        if (airportData) {
            reset({
                ...airportData,
                country: { value: airportData.country, label: countries.find(c => c.value === airportData.country)?.label },
                timezone: { value: airportData.timezone, label: `${airportData.timezone} (${moment.tz(airportData.timezone).format('Z')})` }
            })
        }
    }, [airportData, reset])

    const handleFormSubmit = (data) => {
        onSubmit(data)
    }

    if (!isOpen) return null


    return (
        <>
            <div className="modal-backdrop show"></div>
            <div className="modal d-block show" tabIndex="-1" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">
                                {mode === 'update' ? 'Update Airport' : 'Add Airport'}
                            </h5>
                            <button type="button" className="btn-close" onClick={onClose}></button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit(handleFormSubmit)}>
                                <div className="mb-3">
                                    <label className="form-label">Airport Code:</label>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.code ? 'is-invalid' : ''}`}
                                        placeholder="XXX"
                                        {...register('code')}
                                        disabled={mode === 'update'}
                                    />
                                    {errors.code && (
                                        <div className="invalid-feedback">{errors.code.message}</div>
                                    )}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Label:</label>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.label ? 'is-invalid' : ''}`}
                                        {...register('label')}
                                    />
                                    {errors.label && (
                                        <div className="invalid-feedback">{errors.label.message}</div>
                                    )}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Airport Name:</label>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.label ? 'is-invalid' : ''}`}
                                        {...register('name')}
                                    />
                                    {errors.label && (
                                        <div className="invalid-feedback">{errors.label.message}</div>
                                    )}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Address:</label>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.address ? 'is-invalid' : ''}`}
                                        {...register('address')}
                                    />
                                    {errors.address && (
                                        <div className="invalid-feedback">{errors.address.message}</div>
                                    )}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Country:</label>
                                    <Controller
                                        name="country"
                                        control={control}
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                options={countryOptions}
                                                className={errors.country ? 'is-invalid' : ''}
                                                placeholder="Select a country"
                                                isClearable
                                            />
                                        )}
                                    />
                                    {errors.country && (
                                        <div className="invalid-feedback d-block">{errors.country.message}</div>
                                    )}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Timezone:</label>
                                    <Controller
                                        name="timezone"
                                        control={control}
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                options={timezoneOptions}
                                                className={errors.timezone ? 'is-invalid' : ''}
                                                placeholder="Select a timezone"
                                                isClearable
                                            />
                                        )}
                                    />
                                    {errors.timezone && (
                                        <div className="invalid-feedback d-block">{errors.timezone.message}</div>
                                    )}
                                </div>

                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={onClose}>
                                        Cancel
                                    </button>
                                    <button type="submit" className="btn btn-primary">
                                        {mode === 'update' ? 'Update' : 'Add'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AirportModal 